import React from "react";

import { VisibilityContext } from "react-horizontal-scrolling-menu";
import LeftArrow from "../../../components/SVGComponents/LeftArrow";
import RightArrow from "../../../components/SVGComponents/RightArrow";

export function LeftArrowFunction() {
  const {
    isFirstItemVisible,
    scrollPrev,
    visibleItemsWithoutSeparators,
    getPrevElement,
    scrollToItem,
    visibleElements,
    initComplete
  } = React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(
    //!visibleItemsWithoutSeparators.length && isFirstItemVisible
    !initComplete || (initComplete && isFirstItemVisible)
  );
  React.useEffect(() => {
    // NOTE: detect if whole component visible
    if (visibleElements.length) {
      setDisabled(isFirstItemVisible);
    }else{
      setDisabled((prev)=>!prev);
    }
  }, [isFirstItemVisible, visibleElements]);
  const clickHandler = () => scrollToItem(getPrevElement(), "smooth", "start");
  return (
   
    <div className="left-arrow-css"  onClick={clickHandler} 
    //style={{cursor:disabled?'not-allowed':'pointer'}}
    style={{display:disabled?'none':'flex'}}
    >
        <LeftArrow active={!disabled}/>
    </div>
  );
}

export function RightArrowFunction() {
  const {
    isLastItemVisible,
    scrollNext,
    visibleItemsWithoutSeparators,
    getNextElement,
    scrollToItem,
    visibleElements
  } = React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(
    // !visibleItemsWithoutSeparators.length && isLastItemVisible
    !visibleElements.length && isLastItemVisible
  );
  React.useEffect(() => {
    if (visibleElements.length) {
      setDisabled(isLastItemVisible);
    }else{
      setDisabled((prev)=>!prev);
    }
  }, [isLastItemVisible, visibleElements]);
  const clickHandler = () => scrollToItem(getNextElement(), "smooth", "end");
  return (

    <div  onClick={clickHandler} className="right-arrow-css" 
    //style={{cursor:disabled?'not-allowed':'pointer'}}
    style={{visibility:disabled?'hidden':'visible'}}
    >
        <RightArrow active={!disabled}/>
    </div>

    // <Arrow disabled={disabled} onClick={() => scrollNext()}>
      
    // </Arrow>
  );
}
